<template>
<div class="container">
  <img class="bg" :src="$getImgUrl('/img/activity/refuel/refuel3-bg.png')"  />
  <div v-if="!isEndDate">
    <img v-if="supportStatus=='100'" @click="supportSuccess" class="btn" :src="$getImgUrl('/img/activity/refuel/refuel1-share-btn-3.png')" />
    <img v-else @click="support" class="btn" :src="$getImgUrl('/img/activity/refuel/refuel1-share-btn-1.png')"/>
  </div>

</div>
</template>

<script>
import activityApi from '@/api/activity'
import { sessionStorageUtils } from '@/utils/sessionstorage'
export default {
  data () {
    return {
      params: {},
      supportStatus: '',
      isEndDate: false
    }
  },
  mounted () {
    let dateNow = Date.now()
    if (dateNow > 1654012800000) {
      this.isEndDate = true
      this.$dialog.alert({ message: '活动已结束！' })
    }
    this.init()
  },
  methods: {
    init () {
      let wxUserInfo = sessionStorageUtils.get('wxUserInfo') || ''
      // if (this.$route.query.user && wxUserInfo) {
      this.params = {
        clientId: this.$route.query.user || '',
        wxOpenId: wxUserInfo.openId,
        wxNickName: wxUserInfo.wxNickName,
        // wxOpenId: 'osI4Xs6hKccVSSPo_xGq63oe-8IM',
        // wxNickName: '111',
        requestKey: this.$route.query.key || ''
      }
      console.log(this.params)
      activityApi.refuelSupportStatus(this.params).then(res => {
        if (res.data.resultCode === '0') {
          this.supportStatus = res.data.resultData.supportStatus
        }
      })
    },
    supportSuccess () {
      this.$dialog.alert({
        title: '提示',
        message: '您已为该好友加过油了哦！'
      }).then(() => {
      })
    },
    support () {
      activityApi.refuelWxSupport(this.params).then(res => {
        if (res.data.resultCode === '0') {
          this.supportStatus = res.data.resultMsg
          if (this.supportStatus === '100') {
            this.$dialog.alert({
              title: '提示',
              message: '您已为该好友加过油了哦！'
            }).then(() => {
            })
          } else if (this.supportStatus === '200') {
            this.$dialog.alert({
              title: '提示',
              message: '加油成功，好友获得100ml油量'
            }).then(() => {
            })
          } else if (this.supportStatus === '300') {
            this.$dialog.alert({
              title: '提示',
              message: '加油失败，您今日已达到助力上线！'
            }).then(() => {
            })
          }
          this.init()
        }
      })
    }
  }
}
</script>

<style scoped>
.bg{
  width: 100%;
}
.btn{
  width: 50vw;
  position: absolute;
  left: 25vw;
  top: 390px;
}
</style>
